<div mat-dialog-content>
  <img src="../../../assets/images/earthscoutIcon.PNG" class="img-icon" style="max-height: 30px" />
  <b class="list-inline-item font-weight-bold text-uppercase">
    {{log.sequenceNumber}}
  </b>
  <b style="float: right;">{{ log.boardVersion }}</b>
  <div>
    <div>
      <b class="text dashboard-text font-weight-bold">Serial: {{ log.serial }}</b>
      <br />
      <i class="material-icons log-icon">timer</i>
      <b class="text dashboard-text">Log Recorded At:
        <b class="font-weight-bold">{{log.testResult.time | date: "MMM d, y, h:mm a"}}</b>
      </b>
      <br />
      <i class="material-icons log-icon" style="color: yellow">flash_on</i>
      <b class="text dashboard-text">
        Battery Voltage:
        <b class="font-weight-bold">{{ log.batteryVoltage }} V</b>
      </b>
      <br />
      <i class="material-icons log-icon">sim_card</i>
      <b class="text dashboard-text font-weight-bold">Modem: {{log.modem.simCardSerial}}</b>
      <br />
      <b class="text dashboard-text" style="padding-left: 20px;">
        SimCardSerial:
        <b class="font-weight-bold">{{ log.modem.simCardSerial }}</b>
      </b>
      <br />
      <b class="text dashboard-text" style="padding-left: 20px;">
        IMEI:
        <b class="font-weight-bold">{{ log.modem.imei }}</b>
      </b>
      <br />
      <b class="text dashboard-text" style="padding-left: 20px;">
        EnableCell:
        <b class="font-weight-bold">{{ log.modem.enableCell }}</b>
      </b>
      <br />
      <b class="text dashboard-text" style="padding-left: 20px;">
        SignalQuality:
        <b class="font-weight-bold">{{ log.modem.signalQuality }}</b>
      </b>
      <br />
      <b class="text dashboard-text" style="padding-left: 20px;">
        Startup:
        <b class="font-weight-bold">{{ log.modem.startup }}</b>
      </b>
      <br />
      <i class="material-icons log-icon">usb</i>
      <b class="text dashboard-text">
        Connectivity Code:
        <b class="font-weight-bold">{{ log.connectivityCode }}</b>
      </b>
      <br />
      <i class="material-icons log-icon">confirmation_number</i>
      <b class="text dashboard-text">
        Model Number:
        <b class="font-weight-bold">{{ log.modelNumber }}</b>
      </b>
      <br />
      <i class="material-icons log-icon">bubble_chart</i>
      <b class="text dashboard-text">
        Product Line:
        <b class="font-weight-bold">{{ log.productLine }}</b>
      </b>
      <br />
      <hr />
      <div style="max-height: 60px">
        @if (log.validated) {
          <i class="material-icons" style="color: #78be20; float: right;">done</i>
        }
        @if (!log.validated) {
          <i class="material-icons" style="color: red; float: right">clear</i>
        }
        @if (!log.validatedBy) {
          <div class="text dashboard-text">
            Not previously verified
          </div>
        }
        @if (log.validatedBy) {
          <div class="text dashboard-text">
            Last verified by: {{ log.validatedBy }}
          </div>
        }
      </div>
    </div>
  </div>
  <div>
    <p class="list-inline-item font-weight-bold text-uppercase" style="padding-left: 2.5vw">
      Sensors ({{ log.sensors.length }})
    </p>
    <br/>
    @for (sensor of log.sensors | sort: 'port'; track sensor; let i = $index) {
      <li class="list-inline-item" id="grow">
        @if (sensor.testSensor === true) {
          <div class="text dashboard-text"
            style="padding-left: 5vw; color: orangered">
            Id: <b>{{ sensor.sensor }}</b>
          </div>
        } @else {
          <div class="text dashboard-text" style="padding-left: 5vw; color: #78be20">
            Id: <b>{{ sensor.sensor }}</b>
          </div>
        }
        <div class="text dashboard-text" style="padding-left: 5vw">
          Data: <b>{{ sensor.data }}</b>
        </div>
      </li>
    }
  </div>
  <hr style="margin-top: 0px" />
  <div (click)="clickTestResult(log)">
    <p class="list-inline-item font-weight-bold text-uppercase" style="padding-left: 2.5vw">
      Test Result
    </p>
    <div class="text dashboard-text">
      <b>{{ log.testResult.message }}</b>
    </div>
  </div>
</div>
<div mat-dialog-actions>
  <div class="col-12">
    <button mat-icon-button [matMenuTriggerFor]="menu">
      <span>Actions</span>
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <button style="color: #78be20" mat-menu-item [ngClass]="{ enabled: log.validatedBy }"
        (click)="createAssetsDialog(log)">
        <span>Create Assets</span>
      </button>
      @if (!log.validated) {
        <button style="color: #78be20" mat-menu-item (click)="logDialog(log)">
          <mat-icon style="color: #78be20">done</mat-icon>
          <span>Verify Unit</span>
        </button>
      } @else {
        <button style="color: red" mat-menu-item (click)="logDialog(log)">
          <mat-icon style="color: red">clear</mat-icon>
          <span>Return</span>
        </button>
      }
      <button mat-menu-item [ngClass]="{ enabled: !log.validatedBy && !log.validated }">
        <mat-icon>search</mat-icon>
        <span>Search</span>
      </button>
    </mat-menu>
  </div>
</div>